



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Account } from '@/modules/admin/me';
import { UserTypes } from '@/enums/userTypes';

@Component
export default class Header extends Vue {
  private UserTypes = UserTypes;

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  get user(): Account {
    return this.$store.state.me.user;
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  get schoolName(): string {
    if (!this.user) {
      return '';
    } else {
      return this.user.schoolName;
    }
  }

  get userName(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName}　${this.user.firstName}`;
    }
  }

  get myPageTitle(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName} ${this.user.firstName} さんの情報`;
    }
  }

  private created() {
    this.loadData();
  }

  private loadData() {
    this.$store.dispatch('me/fetchMyData');
  }

  private async onChangeSchool(schoolId: string) {
    if (schoolId === this.schoolId) { return; }
    try {
      await this.$store.dispatch('auth/changeSchool', schoolId);
      window.location.reload();
    } catch (error) {
      this.$notify.error({
        title: 'スクール切替エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private operate(command: string) {
    this.$router.push(command);
  }

  private onClickMenu() {
    this.$emit('clickMenu');
  }
}
